var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 41,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56992 18.8231V18.1881C2.56992 17.6873 2.20854 17.2278 1.70776 17.1814C1.1347 17.1246 0.649414 17.5737 0.649414 18.1365V18.8231C0.649414 19.3548 1.07791 19.7833 1.60967 19.7833C2.14142 19.7833 2.56992 19.3548 2.56992 18.8231Z",
    fill: "url(#paint0_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.654785 21.7503V22.3646C0.654785 22.8654 1.01617 23.3249 1.51695 23.3714C2.09 23.4282 2.57529 22.979 2.57529 22.4163V21.7503C2.57529 21.2185 2.14679 20.79 1.61504 20.79C1.08329 20.79 0.654785 21.2185 0.654785 21.7503Z",
    fill: "url(#paint1_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27695 20.8263V15.6637C6.27695 15.1629 5.91557 14.7034 5.41479 14.657C4.84174 14.6002 4.35645 15.0493 4.35645 15.612V20.8315C4.35645 21.3632 4.78495 21.7917 5.3167 21.7917C5.84845 21.7917 6.27695 21.3632 6.27695 20.8315V20.8263Z",
    fill: "url(#paint2_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36133 23.7535V24.8841C4.36133 25.3849 4.72271 25.8444 5.22349 25.8908C5.79655 25.9476 6.28184 25.4985 6.28184 24.9358V23.7483C6.28184 23.2166 5.85334 22.7881 5.32158 22.7881C4.78983 22.7881 4.36133 23.2166 4.36133 23.7483V23.7535Z",
    fill: "url(#paint3_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9835 15.2143V14.3883C9.9835 13.8875 9.62211 13.428 9.12133 13.3816C8.54828 13.3248 8.06299 13.7739 8.06299 14.3367V15.2195C8.06299 15.7512 8.49149 16.1797 9.02324 16.1797C9.555 16.1797 9.9835 15.7512 9.9835 15.2195V15.2143Z",
    fill: "url(#paint4_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06836 18.1366V26.1593C8.06836 26.6601 8.42975 27.1196 8.93052 27.166C9.50358 27.2228 9.98887 26.7737 9.98887 26.211V18.1314C9.98887 17.5996 9.56037 17.1711 9.02861 17.1711C8.49686 17.1711 8.06836 17.5996 8.06836 18.1314V18.1366Z",
    fill: "url(#paint5_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6905 23.7379V12.7879C13.6905 12.2872 13.3291 11.8277 12.8284 11.7812C12.2553 11.7244 11.77 12.1736 11.77 12.7363V23.7379C11.77 24.2697 12.1985 24.6982 12.7303 24.6982C13.262 24.6982 13.6905 24.2697 13.6905 23.7379Z",
    fill: "url(#paint6_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7749 26.66V27.7596C11.7749 28.2604 12.1363 28.7199 12.6371 28.7663C13.2101 28.8231 13.6954 28.374 13.6954 27.8112V26.66C13.6954 26.1282 13.2669 25.6997 12.7352 25.6997C12.2034 25.6997 11.7749 26.1282 11.7749 26.66Z",
    fill: "url(#paint7_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3971 13.8258V11.9569C17.3971 11.4561 17.0357 10.9966 16.5349 10.9502C15.9619 10.8934 15.4766 11.3425 15.4766 11.9053V13.8309C15.4766 14.3575 15.9051 14.7809 16.4265 14.7757C16.4368 14.7757 16.4471 14.7757 16.4575 14.7757C16.9789 14.7757 17.3971 14.3524 17.3971 13.8309V13.8258Z",
    fill: "url(#paint8_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4819 16.7168V28.5909C15.4819 29.0917 15.8433 29.5511 16.3441 29.5976C16.9172 29.6544 17.4024 29.2052 17.4024 28.6425V16.7116C17.4024 16.1902 16.9843 15.772 16.4628 15.7668C16.4525 15.7668 16.4422 15.7668 16.4319 15.7668C15.9104 15.7668 15.4819 16.185 15.4819 16.7116V16.7168Z",
    fill: "url(#paint9_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1036 22.4318V10.8055C21.1036 10.3047 20.7422 9.84526 20.2414 9.7988C19.6684 9.74201 19.1831 10.1912 19.1831 10.7539V22.4318C19.1831 22.9636 19.6116 23.3921 20.1434 23.3921C20.6751 23.3921 21.1036 22.9636 21.1036 22.4318Z",
    fill: "url(#paint10_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1885 25.359V29.7421C19.1885 30.2428 19.5499 30.7023 20.0506 30.7488C20.6237 30.8056 21.109 30.3564 21.109 29.7937V25.3538C21.109 24.8221 20.6805 24.3936 20.1487 24.3936C19.617 24.3936 19.1885 24.8221 19.1885 25.3538V25.359Z",
    fill: "url(#paint11_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8106 16.1127V10.8055C24.8106 10.3047 24.4493 9.84526 23.9485 9.7988C23.3754 9.74201 22.8901 10.1912 22.8901 10.7539V16.1179C22.8901 16.6496 23.3186 17.0781 23.8504 17.0781C24.3821 17.0781 24.8106 16.6496 24.8106 16.1179V16.1127Z",
    fill: "url(#paint12_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8955 19.0398V29.742C22.8955 30.2428 23.2569 30.7023 23.7577 30.7487C24.3307 30.8055 24.816 30.3564 24.816 29.7937V19.0398C24.816 18.5081 24.3875 18.0796 23.8558 18.0796C23.324 18.0796 22.8955 18.5081 22.8955 19.0398Z",
    fill: "url(#paint13_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5172 20.5269V11.9569C28.5172 11.4561 28.1558 10.9966 27.655 10.9502C27.082 10.8934 26.5967 11.3425 26.5967 11.9053V20.5321C26.5967 21.0638 27.0252 21.4923 27.5569 21.4923C28.0887 21.4923 28.5172 21.0638 28.5172 20.5321V20.5269Z",
    fill: "url(#paint14_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6021 23.4539V28.5908C26.6021 29.0916 26.9634 29.551 27.4642 29.5975C28.0373 29.6543 28.5226 29.2051 28.5226 28.6424V23.4488C28.5226 22.917 28.0941 22.4885 27.5623 22.4885C27.0306 22.4885 26.6021 22.917 26.6021 23.4488V23.4539Z",
    fill: "url(#paint15_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2242 14.3264V12.7879C32.2242 12.2872 31.8628 11.8277 31.3621 11.7812C30.789 11.7244 30.3037 12.1736 30.3037 12.7363V14.3316C30.3037 14.853 30.727 15.2763 31.2485 15.2763C31.2588 15.2763 31.2691 15.2763 31.2795 15.2763C31.8009 15.2763 32.2242 14.853 32.2242 14.3316V14.3264Z",
    fill: "url(#paint16_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2797 16.2779C30.7427 16.2779 30.3091 16.7115 30.3091 17.2484V27.8112C30.3091 28.374 30.7944 28.8231 31.3674 28.7663C31.8682 28.7147 32.2296 28.2604 32.2296 27.7596V17.2175C32.2296 16.696 31.8063 16.2727 31.2848 16.2727L31.2797 16.2779Z",
    fill: "url(#paint17_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9313 21.5283V14.3832C35.9313 13.8824 35.5699 13.4229 35.0691 13.3764C34.496 13.3196 34.0107 13.7688 34.0107 14.3315V21.5283C34.0107 22.06 34.4392 22.4885 34.971 22.4885C35.5028 22.4885 35.9313 22.06 35.9313 21.5283Z",
    fill: "url(#paint18_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0156 24.4556V26.1645C34.0156 26.6652 34.377 27.1247 34.8778 27.1712C35.4508 27.228 35.9361 26.7788 35.9361 26.2161V24.4556C35.9361 23.9239 35.5076 23.4954 34.9759 23.4954C34.4441 23.4954 34.0156 23.9239 34.0156 24.4556Z",
    fill: "url(#paint19_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6378 17.5169V15.6067C39.6378 15.075 39.2093 14.6465 38.6775 14.6465C38.1458 14.6465 37.7173 15.075 37.7173 15.6067V17.5169C37.7173 18.0487 38.1458 18.4772 38.6775 18.4772C39.2093 18.4772 39.6378 18.0487 39.6378 17.5169Z",
    fill: "url(#paint20_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7227 20.4441V24.9408C37.7227 25.4726 38.1512 25.9011 38.6829 25.9011C39.2147 25.9011 39.6432 25.4726 39.6432 24.9408V20.4441C39.6432 19.9124 39.2147 19.4839 38.6829 19.4839C38.1512 19.4839 37.7227 19.9124 37.7227 20.4441Z",
    fill: "url(#paint21_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3448 18.5237V18.1881C43.3448 17.6873 42.9834 17.2278 42.4827 17.1814C41.9096 17.1246 41.4243 17.5737 41.4243 18.1365V18.5237C41.4243 19.0554 41.8528 19.4839 42.3846 19.4839C42.9163 19.4839 43.3448 19.0554 43.3448 18.5237Z",
    fill: "url(#paint22_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4292 21.4459V22.3596C41.4292 22.8604 41.7906 23.3199 42.2914 23.3664C42.8644 23.4231 43.3497 22.974 43.3497 22.4113V21.4459C43.3497 20.9141 42.9212 20.4856 42.3894 20.4856C41.8577 20.4856 41.4292 20.9141 41.4292 21.4459Z",
    fill: "url(#paint23_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8151 15.2143C40.5002 15.2143 40.2111 15.013 40.113 14.6981C37.6607 6.78373 30.4381 1.46619 22.1469 1.46619C13.8557 1.46619 6.63314 6.78373 4.18088 14.6981C4.06213 15.0853 3.64912 15.3021 3.26192 15.1834C2.87472 15.0646 2.65789 14.6516 2.77663 14.2644C5.42508 5.73055 13.2104 0 22.1469 0C31.0835 0 38.8688 5.73055 41.512 14.2644C41.6308 14.6516 41.4139 15.0646 41.0267 15.1834C40.9545 15.204 40.8822 15.2143 40.8099 15.2143H40.8151Z",
    fill: "url(#paint24_linear_71_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1471 40.5474C13.2054 40.5474 5.42528 34.8169 2.782 26.283C2.66326 25.8958 2.88009 25.4828 3.26729 25.364C3.64933 25.2453 4.06751 25.4621 4.18625 25.8493C6.63851 33.7637 13.8611 39.0812 22.1523 39.0812C30.4435 39.0812 37.6661 33.7637 40.1183 25.8493C40.2371 25.4621 40.6501 25.2453 41.0373 25.364C41.4245 25.4828 41.6413 25.8958 41.5226 26.283C38.8793 34.8117 31.094 40.5474 22.1575 40.5474H22.1471Z",
    fill: "url(#paint25_linear_71_299)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_299",
    x1: 1.61483,
    y1: 42.2925,
    x2: 1.61483,
    y2: 3.8772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_299",
    x1: 0.654785,
    y1: 42.2925,
    x2: 1.17105,
    y2: 3.87718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_299",
    x1: 5.32186,
    y1: 42.2927,
    x2: 5.32186,
    y2: 3.87733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_299",
    x1: 5.32158,
    y1: 42.2926,
    x2: 5.32158,
    y2: 3.87727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_299",
    x1: 9.0284,
    y1: 42.2924,
    x2: 9.0284,
    y2: 3.87711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_299",
    x1: 9.02861,
    y1: 42.2926,
    x2: 9.02861,
    y2: 3.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_299",
    x1: 12.7354,
    y1: 42.2925,
    x2: 12.7354,
    y2: 3.87719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_299",
    x1: 12.7352,
    y1: 42.2925,
    x2: 12.7352,
    y2: 3.87715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_299",
    x1: 16.442,
    y1: 42.2927,
    x2: 16.442,
    y2: 3.87732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_71_299",
    x1: 16.4422,
    y1: 42.2926,
    x2: 16.4422,
    y2: 3.87725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_71_299",
    x1: 20.1434,
    y1: 42.2926,
    x2: 20.1434,
    y2: 3.87723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_71_299",
    x1: 20.1436,
    y1: 42.2925,
    x2: 20.1436,
    y2: 3.87716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_71_299",
    x1: 23.8504,
    y1: 42.2926,
    x2: 23.8504,
    y2: 3.87723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_71_299",
    x1: 23.8506,
    y1: 42.2924,
    x2: 23.8506,
    y2: 3.87712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_71_299",
    x1: 27.5569,
    y1: 42.2927,
    x2: 27.5569,
    y2: 3.87732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_71_299",
    x1: 27.5571,
    y1: 42.2925,
    x2: 27.5571,
    y2: 3.87715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_71_299",
    x1: 31.264,
    y1: 42.2925,
    x2: 31.264,
    y2: 3.87719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_71_299",
    x1: 31.2642,
    y1: 42.2925,
    x2: 31.2642,
    y2: 3.87717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_71_299",
    x1: 34.971,
    y1: 42.2925,
    x2: 34.971,
    y2: 3.87715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_71_299",
    x1: 34.9707,
    y1: 42.2926,
    x2: 34.9707,
    y2: 3.87726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_71_299",
    x1: 38.6775,
    y1: 42.2925,
    x2: 38.6775,
    y2: 3.87719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_71_299",
    x1: 38.6777,
    y1: 42.2925,
    x2: 38.6777,
    y2: 3.87718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_71_299",
    x1: 42.3846,
    y1: 42.2925,
    x2: 42.3846,
    y2: 3.87719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_71_299",
    x1: 42.3843,
    y1: 42.2926,
    x2: 42.3843,
    y2: 3.87734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_71_299",
    x1: 22.1469,
    y1: 42.2925,
    x2: 22.1469,
    y2: 3.87716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_71_299",
    x1: 22.1471,
    y1: 42.2924,
    x2: 22.1471,
    y2: 3.87706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BF81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.69,
    height: 40.5475,
    fill: "white",
    transform: "translate(0.654785)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/objects.46dd739229c19ab69da8983bd89d752c.svg";
export { ForwardRef as ReactComponent };